import gettext from 'i18n/gettext';
const flow = {
    name: gettext('ID and Residence Verification'),
    steps: [
        {
            key: 'tutorial',
            state: 'setup.documents.tutorial',
            heading: gettext('Verifying Your Identity with Jumio'),
            label: gettext('Jumio Tutorial'),
            returnTo: 'setup'
        },
        {
            key: 'netverify',
            state: 'setup.documents.id',
            heading: gettext('Verify Your Identity'),
            label: gettext('Verify Identity'),
            keepStateOnPrev: true,
        },
        {
            key: 'upload-poa',
            state: 'setup.documents.residence',
            heading: gettext('Upload Proof of Residence'),
            label: gettext('Upload Proof of Residence'),
        },
        {
            key: 'complete',
            state: 'setup.complete',
            label: gettext('Complete'),
        },
    ],
};
export default flow;



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/onboarding/controllers/setup/documents/flow.ts